import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/shared/stores/authStore';
import { ROUTES } from '@/shared/config/constants';
import { Skeleton } from '@/shared/ui';

const AppShellSkeleton = () => (
  <div
    className="flex min-h-dvh flex-col bg-background"
    aria-busy="true"
    aria-label="Carregando sessão"
  >
    <header className="flex items-center justify-between bg-background px-4 py-3">
      <div className="flex items-center gap-2">
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="flex items-center gap-2">
        <Skeleton className="size-9 rounded-full" />
        <Skeleton className="size-9 rounded-full" />
      </div>
    </header>
    <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col gap-4 p-4 lg:p-8">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-7 w-40" />
        <Skeleton className="h-3 w-72" />
      </div>
      <div className="mt-2 flex flex-col gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          // Skeleton SEM border: em hard reload (Ctrl+Shift+R), a CSS
          // variable --color-border pode demorar para chegar e o browser
          // pinta border-color com currentColor (preto), causando flash
          // de borda forte. Sem border, sem flash. Mesmo principio do
          // refactor de skeletons das telas autenticadas.
          <div
            key={i}
            className="flex items-start gap-3 rounded-2xl bg-background p-4"
          >
            <Skeleton className="size-12 shrink-0 rounded-full" />
            <div className="flex flex-1 flex-col gap-2">
              <div className="flex items-center justify-between">
                <Skeleton className="h-3.5 w-40" />
                <Skeleton className="h-6 w-12 rounded-full" />
              </div>
              <Skeleton className="h-3 w-56" />
              <Skeleton className="h-3 w-44" />
              <div className="mt-1 flex gap-2">
                <Skeleton className="h-9 w-16 rounded-full" />
                <Skeleton className="h-9 w-32 rounded-full" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </main>
  </div>
);

export const ProtectedRoute = () => {
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const user = useAuthStore((s) => s.user);

  if (isHydrating) return <AppShellSkeleton />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }

  if (user && !user.onboardingCompleto) {
    return <Navigate to={ROUTES.ONBOARDING} replace />;
  }

  return <Outlet />;
};
